<template>
    <e-charts :options="option" :init-options="initOptions" ref="map" autoresize />
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import { spawn } from 'child_process'

export default {
    name: 'barChartNormal',
    components: {
        ECharts
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        orderDataSource: {
            type: String,
            default: 'G'
        }
    },
    data() {
        return {
            legendData: [],
            keysData: [],
            colorData: ['#325ec9', '#b8741a', '#f59a23', '#09bb07', '#999999']
        }
    },
    computed: {
        initOptions() {
            return {
                renderer: 'canvas'
            }
        },
        option() {
            return {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '2%',
                    top: '40px',
                    containLabel: true
                },
                legend: {
                    x: 'center',
                    y: '10px',
                    data: this.legendData
                },
                xAxis: {
                    type: 'category',
                    data: this.list.map(el => el.serviceTypeName)
                },
                yAxis: {
                    type: 'value'
                },
                series: this.series
            }
        },
        series() {
            return this.keysData.map((key, index) => {
                return {
                    name: this.legendData[index] || '',
                    type: 'bar',
                    stack: '总量',
                    barWidth: 50,
                    data: this.list.map(el => el[key] || 0),
                    color: this.colorData[index] || this.variables.linkColor
                }
            })
        }
    },
    watch: {
        orderDataSource: {
            handler: function(el) {
                if(el == "G") {
                    this.legendData = ['待派单', '执行中', '待验收', '已存档', '已取消']
                    this.keysData= ['allocation', 'running', 'accept', 'archive', 'cancel']
                }else {
                    this.legendData = ['待接收', '执行中', '待验收', '已存档', '已取消']
                    this.keysData= ['receive', 'running', 'accept', 'archive', 'cancel']
                }
            },
            immediate:true
        }
    },
    methods: {}
}
</script>
<style lang="less" scoped>
.echarts {
    width: 100%;
    height: 100%;
}
</style>
